import React from "react";
import styled from "styled-components";
import { H2Desk, H3Desk, P3Desk } from "../../../styles/styles_text";
import {ReactComponent as IconVencido} from "../../../assets/kinologyIcons/svg/warningInvoices.svg";
import {ReactComponent as IconCheck} from "../../../assets/kinologyIcons/svg/check_circle.svg";
import { useDispatch, useSelector } from "react-redux";
import { FaturaProps } from "../../../interfaces/cartao.interface";
import { FinancialActions } from "../../../store/ducks/financial";
import { Colors } from "../../../styles/colors";
import moment from "moment";
import {ReactComponent as OpenEnvoice} from '../../../assets/kinologyIcons/svg/openEnvoice.svg';

interface Invoice {
	id: string;
	status: "pendente" | "PAID";
	amount: string;
	dueDate: string;
}

const InvoiceComponent: React.FC = () => {
	const dispatch = useDispatch();
	const faturas = useSelector((state: any) => state.financial.faturas);
	
	const current_language = useSelector(
		(state: any) => state.configs.current_language
	);

	const formatPrice = (price: any) =>
		(price / 100)?.toFixed(2).replace(/\./g, ",");

	const PagarFatura = (fatura: FaturaProps) => {

		if (fatura.FATURA_FORMA_PAGAMENTO == "Cartão de crédito") {
			dispatch(FinancialActions.set_modal_pagamento_cartao(true, fatura));
		}else{
			dispatch(dispatch(FinancialActions.set_modal_escolha_pagamento(true)))
		}
	};
	

	const PaymentCard = (item:FaturaProps, index: number)=>{
		const envoiceValidate = item?.FATURA_VALIDADE?.split('/');
		const formatDate = envoiceValidate[1]+ '/' + envoiceValidate[0]+ '/' + envoiceValidate[2]

		const today = moment()
		const envoiceValidity = moment(formatDate, 'DD/MM/YYYY')
		
		return (
			<InvoiceItem key={item.FATURA_URL} status={"PENDING"}>
				<InvoiceInfo>
					<Strong
						 style={{
							color: item?.FATURA_TIPO === "PENDING"
							? envoiceValidity.isBefore(today, 'day')
								? Colors.tertirary_red_2_dark 
								: Colors?.primary_blue_k_dark_2
							: Colors.secondary_green_k_dark_2
						 }}
					>
					{
						item?.FATURA_TIPO === "PENDING"
						?  envoiceValidity.isBefore(today, 'day')
							? current_language?.menu_lateral_fatura_pendente 
							: current_language?.fatura_aberto
						: current_language?.fatura_paga
					}
					</Strong>
					<P3Desk >
						<strong style={{color: Colors?.primary_blue_k_main+53}}>
							{current_language?.vencimento}: {formatDate}
						</strong>
					</P3Desk>
					<Strong
					 style={{
						color: item?.FATURA_TIPO === "PENDING"
						? envoiceValidity.isBefore(today, 'day')
							? Colors.tertirary_red_2_dark 
							: Colors?.primary_blue_k_dark_2
						: Colors.secondary_green_k_dark_2
					 }}
					>
						{
							item?.FATURA_TIPO === "PENDING"
							? envoiceValidity.isBefore(today, 'day')
								? <IconVencido width={22} height={22} style={{marginRight: 5}} />
								: <OpenEnvoice  color={Colors?.primary_blue_k_dark_2} />
							: <IconCheck  width={22} height={22} style={{marginRight: 5}} color={Colors.secondary_green_k_dark_2}/>
						}
				
						{"R$" + formatPrice(item?.FATURA_VALOR)}
					</Strong>
				</InvoiceInfo>
				<InvoiceAction onClick={() => PagarFatura(item)} visible={ item?.FATURA_TIPO === "PENDING" && envoiceValidity.isBefore(today, 'day')}>
					{item?.FATURA_TIPO === "PENDING" && (
						<a>{current_language?.pagar_fatura}</a>
					)}
				</InvoiceAction>
			</InvoiceItem>
		)
	}

	return (
		<Container>
			<Title>{current_language?.visualizar_faturas}</Title>
			<InvoiceList>
				{faturas.map((invoice: FaturaProps, index: number) => (
					PaymentCard(invoice, index)
				))}
			</InvoiceList>
		</Container>
	);
};

const Container = styled.div`
	height: 100vh;
	width: 100%;
	margin-top: 4rem;
`;

const Title = styled.h1`
	font-size: 20px;
	color: #002060;
	margin-bottom: 16px;
`;

const InvoiceList = styled.ul`
	padding: 0;
	height: 50vh;
	overflow-x: hidden;
	padding-bottom:5rem;

	overflow-y: scroll;
	::-webkit-scrollbar {
		width: 10px;
		height: 10px;
	}
	::-webkit-scrollbar-thumb {
		background: #e0e0e0;
		border-radius: 10px;
	}
	::-webkit-scrollbar-track {
		background: #ffffff;
		border-radius: 10px;
	}
`;

const InvoiceItem = styled.li<{ status: "PENDING" | "PAID" }>`
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding-bottom: 12px;
	padding-top: 12px;
	color: ${(props) => (props.status === "PENDING" ? "#A81F00" : Colors.secondary_green_k_dark_2)};
`;

const InvoiceInfo = styled.div`
	display: flex;
	flex-direction: column;
`;

const Strong = styled.strong`
display: flex;
	margin-top: 0.5rem;
	align-items: center;
	/* justify-content: center; */
`;

const InvoiceAction = styled.div<{visible?: boolean}>`
	display: ${({visible})=> visible ? 'flex' : 'none'};
	font-size: 14px;
	color:#797D8D;
	text-decoration: underline;
	cursor: pointer;
`;		

const StatusIcon = styled.span<{ status: "pendente" | "PAID" }>`
	font-size: 16px;
	margin-right: 8px;
	color: ${(props) => (props.status === "pendente" ? "#A81F00" : "#008000")};
`;

export default InvoiceComponent;

